export enum GroceryUnit {
  G = 'g',
  MG = 'mg',
  ML = 'ml',
  TSP = 'tsp',
  PCS = 'pcs',
}

export enum MealType {
  BREAKFAST = 'breakfast',
  DINNER = 'dinner',
  LUNCH = 'lunch',
  SNACK = 'snack',
  HYDRATION = 'hydration',
}

export enum NutritionUnit {
  G = 'g',
  MG = 'mg',
  KCAL = 'kcal',
}

export enum NutritionValueName {
  ENERGY = 'Energy',
  FAT = 'Fat',
  SATURATED_FAT = 'of which saturates',
  CARBOHYDRATE = 'Carbohydrate',
  SUGARS = 'of which sugars',
  PROTEIN = 'Protein',
  FIBER = 'Fibre',
  SALT = 'Salt',
}

export const DEFAULT_NUTRITION_VALUES: {
  name: NutritionValueName;
  value: number;
  unit: NutritionUnit;
}[] = [
  { name: NutritionValueName.ENERGY, value: 0, unit: NutritionUnit.KCAL },
  { name: NutritionValueName.FAT, value: 0, unit: NutritionUnit.G },
  { name: NutritionValueName.SATURATED_FAT, value: 0, unit: NutritionUnit.G },
  { name: NutritionValueName.CARBOHYDRATE, value: 0, unit: NutritionUnit.G },
  { name: NutritionValueName.SUGARS, value: 0, unit: NutritionUnit.G },
  { name: NutritionValueName.PROTEIN, value: 0, unit: NutritionUnit.G },
  { name: NutritionValueName.FIBER, value: 0, unit: NutritionUnit.G },
  { name: NutritionValueName.SALT, value: 0, unit: NutritionUnit.MG },
];
